import { Injectable } from '@angular/core';
import { MenuItem } from '../models/menu-item.model';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  menu: Array<MenuItem> = [
    {nome: "Home", route:"home"},
    {nome: "Sedi", route:"sedi"},
    {nome: "Servizi", route:"servizi"/* , sottomenu: [
      {nome: "Sala pesi", route:"sala-pesi"},
      {nome: "Personal training", route:"pt"},
      {nome: "Integratori alimentari", route:"integratori"},
      {nome: "Fisioterapista e Osteopata", route:"fisioterapista"},
      {nome: "Nutrizionista", route:"nutrizionista"}
    ] */},
    {nome: "Orari corsi", route:"corsi"},
    {nome: "Il nostro team", route: "team"},
    {nome: "Contattaci", route: "contattaci"}
  ]
  constructor() { }
}
